<template>
  <div>
    <div class="row">
      <div class="form-group col-sm-8">
        <label class="access-form__label">Tubage</label>
        <v-select :options="ventingTypeOptions"
          :reduce="venting => venting.value"
          label="name"
          :searchable="false"
          v-model="params.venting_type">
        </v-select>
      </div>
      <div class="form-group col mb-sm-0 align-self-center">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" v-model="params.air_intake" id="option_air_intake" class="custom-control-input" />
          <label class="custom-control-label" for="option_air_intake">Prise d'air</label>
        </div>
      </div>
    </div>
    <div class="row">
      <r-input
        v-model="params.pipe_diameter"
        label="Diamètre du tubage (en mm)"
        type="number"
        :required="false"
        class="col-sm-8" />
    </div>
    <div class="row">
      <div class="form-group col" :class="{ 'col-sm-6 col-md-8': params.pipe_type !== 'plunger' }">
        <label class="access-form__label">Type d'installation</label>
        <v-select :options="pipeTypeOptions"
          :reduce="pipe => pipe.value"
          label="name"
          :searchable="false"
          v-model="params.pipe_type">
        </v-select>
      </div>
      <r-input v-if="params.pipe_type !== 'plunger'"
        v-model="params.pipe_length"
        label="Longueur du conduit (en m)"
        type="number"
        :required="false"
        class="col-sm-6 col-md-4" />
    </div>
    <div class="row">
      <r-input v-if="params.pipe_type === 'bushel'"
        v-model="params.bushel_dimension"
        label="Dimension du boisseau"
        :required="false"
        class="col-sm-8" />
    </div>
    <div class="form-group">
      <label class="access-form__label">Détails de l'installation</label>
      <textarea v-model="params.install_details" class="form-control" rows="5"></textarea>
    </div>

    <div class="row" v-for="(subfiles, i) in chunkedPictures" :key="'subfiles' + i">
      <div class="form-group col-sm" v-for="file in subfiles" :key="file.ref">
        <label class="access-form__label d-flex justify-content-between">
          <span>{{ file.label}}</span>
          <i class="remove-file fa fa-trash" v-if="file.id" @click.prevent="destroyPicture(file)"></i>
        </label>
        <div class="custom-file">
          <input type="file"
            class="custom-file-input"
            :id="file.ref"
            :ref="file.ref"
            @change="directUpload(file.ref)"
            @click="file.error = null"
            :disabled="disableUpload || file.id" />
          <label class="custom-file-label" :for="file.ref" :class="{ 'border-danger': file.error }">
            {{ file.fileName || 'Parcourir' }}
          </label>
          <p class="mb-0">
            <small class="text-danger">{{ file.error }}</small>
          </p>
        </div>
        <progress class="custom-file" max="100" :value="file.progress" v-if="file.progress > 0"></progress>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Installation',
  props: {
    params: Object,
    pictures: Array,
    error: Object,
    formData: FormData
  },
  data () {
    return {
      ventingTypeOptions: [
        { name: 'Simple flux', value: 'simple' },
        { name: 'Double flux', value: 'double' },
        { name: 'Simple flux isolé', value: 'simple_isolated' },
        { name: 'Double flux isolé', value: 'double_isolated' }
      ],
      pipeTypeOptions: [
        { name: 'Ventouse', value: 'plunger' },
        { name: '40cm au-dessus du faitage', value: 'above_jointing' },
        { name: 'En-dessous du faitage', value: 'below_jointing' },
        { name: 'Tubage d\'un boisseau existant', value: 'bushel' }
      ],
      chunkedPictures: _.chunk(this.pictures, 2)
    }
  },
  computed: {
    ...mapState(['currentClient', 'clientAuth']),
    disableUpload () {
      return _.some(this.pictures, p => p.progress > 0)
    }
  },
  methods: {
    directUpload (ref) {
      this.$store.commit('SET_UPLOAD_PROGRESS', true)
      let dataPicture = new FormData()
      let currentPicture = _.find(this.pictures, file => file.ref === ref)
      if (this.$refs[ref][0].files.length > 0) {
        currentPicture.fileName = this.$refs[ref][0].files[0].name
        dataPicture.append('installation_picture[picture]', this.$refs[ref][0].files[0])
        dataPicture.append('installation_picture[picture_type]', ref)
        this.uploadPicture(currentPicture, dataPicture).then(() => {
          this.$store.commit('SET_UPLOAD_PROGRESS', false)
        })
      }
    },
    async uploadPicture (currentPicture, dataPicture) {
      await this.$http.post(`/clients/${this.currentClient.id}/installation_pictures`, dataPicture, {
        headers: {
          ...this.clientAuth,
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => {
          currentPicture.progress = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
        }
      }).then(resp => {
        currentPicture.progress = 0
        currentPicture.id = resp.data.id
        this.formData.append(`picture_${currentPicture.ref}_id[]`, resp.data.id)
        this.formData.append(`picture_${currentPicture.ref}_type`, currentPicture.ref)
      }).catch(err => {
        currentPicture.progress = 0
        if (err.response && err.response.status === 422) {
          currentPicture.error = err.response.data.picture[0]
        } else {
          currentPicture.error = 'Une erreur est survenue pendant le téléchargement.'
        }
        currentPicture.fileName = null
      })
    },
    async destroyPicture (file) {
      if (file.id && confirm('Supprimer la photo définitivement ?')) {
        await this.$http.delete(`/clients/${this.currentClient.id}/installation_pictures/${file.id}`, {
          headers: this.clientAuth
        }).then(() => {
          file.id = null
          file.fileName = null
          this.formData.delete(`picture_${file.ref}_id`)
          this.formData.delete(`picture_${file.ref}_type`)
        })
      }
    }
  }
}
</script>

<style>
  .custom-file-input[disabled] {
    opacity: 0;
  }
  .remove-file {
    font-size: initial;
    cursor: pointer;
  }
</style>
